import React from "react";
import { css, SerializedStyles, useTheme } from "@emotion/react";

import TwoColumn from "./TwoColumn";
import SimpleCheckbox from "./SimpleCheckbox";
import ConditionalWrapper from "core/Components/ConditionalWrapper";
import { OnFieldChange } from "core/hooks/useForm";

export type SimpleCheckboxField = {
    label: string,
    name: string,
    value: boolean,
};

type Props = {
    fields: Array<SimpleCheckboxField>,
    hasError: boolean,
    groupName: string,
    id?: string,
    isTwoColumn?: boolean,
    checkboxStyle?: SerializedStyles,
    onFieldChange: OnFieldChange,
};

const SimpleCheckboxGroup: React.FC<Props> = ({
    fields,
    groupName,
    id,
    hasError,
    isTwoColumn = false,
    checkboxStyle = null,
    onFieldChange,
}) => {
    const theme = useTheme();
    const onChange = (name: string, value: boolean) => {
        const newFields = [...fields];

        const changedIndex = newFields.findIndex(field => field.name === name);

        if (changedIndex >= 0) {
            newFields[changedIndex].value = value;
        }

        onFieldChange(groupName, newFields);
    };

    const checkboxInputStyle = css`
        margin-top: 0;
        box-sizing: border-box;
        width: 100%;
        font-size: ${theme.forms.label.fontSize};
        height: 47px;
        
        ${checkboxStyle};
    `;

    const checkboxes = fields.map((field, index) => (
        <SimpleCheckbox
            css={checkboxInputStyle}
            hasError={hasError}
            key={index}
            label={field.label}
            id={id}
            name={field.name}
            onChange={onChange}
            value={field.value}
        />
    ));

    return (
        <ConditionalWrapper
            condition={isTwoColumn}
            wrap={(children: React.ReactNode) => (
                <TwoColumn>
                    {children}
                </TwoColumn>
            )}
        >
            {checkboxes}
        </ConditionalWrapper>
    );
};

export default SimpleCheckboxGroup;
